// import { useState, useEffect, useCallback } from "react";
// import axiosClient from "../axiosClient";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import { useStateContext } from "../context/ContextProvider";
// import { useTranslation } from "react-i18next";
// import {
//   Grid,
//   TextField,
//   Typography,
//   Box,
//   Divider,
//   Paper,
//   Button
// } from "@mui/material";

// const AssignedClientStats = () => {
//   const [data, setData] = useState([]);
//   const [missingData, setMissingData] = useState([]);
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");
//   const [week, setWeek] = useState("");
//   const [yearError, setYearError] = useState(""); // State for year validation error
//   const { user } = useStateContext();
//   const { t } = useTranslation();

//   // Helper function to get the Monday of the selected week
//   const getMondayOfWeek = (dateString) => {
//     const date = new Date(dateString);
//     const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
//     const diff = day === 0 ? -6 : -day + 1; // Adjust to previous Monday
//     date.setDate(date.getDate() + diff);
//     return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
//   };

//   const validateYear = useCallback((year) => {
//     if (!year) return true;
//     const yearNum = parseInt(year, 10);
//     if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
//       setYearError(t("Year must be between 2000 and 2100"));
//       return false;
//     }
//     setYearError("");
//     return true;
//   }, [t]);

//   const fetchData = useCallback(
//     (url) => {
//       axiosClient
//         .get(url, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//           },
//         })
//         .then((response) => {
//           if (response.data && Array.isArray(response.data)) {
//             setData(response.data);
//           } else {
//             console.error("Invalid data format:", response.data);
//             setData([]);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//           setData([]);
//         });
//     },
//     [user.token]
//   );

//   const fetchDataMissingAppointment = useCallback(
//     (url) => {
//       axiosClient
//         .get(url, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//           },
//         })
//         .then((response) => {
//           if (response.data && Array.isArray(response.data)) {
//             setMissingData(response.data);
//           } else {
//             console.error("Invalid data format:", response.data);
//             setMissingData([]);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching data:", error);
//           setMissingData([]);
//         });
//     },
//     [user.token]
//   );

//   useEffect(() => {
//     if (month) {
//       const [year, mon] = month.split("-");
//       fetchData(`api/assignedClientStats/month/${mon}-${year}/`);
//       fetchDataMissingAppointment(`api/missing-appointment/month/${mon}-${year}/`);
//     }
//   }, [month, fetchData, fetchDataMissingAppointment]);

//   useEffect(() => {
//     if (year && validateYear(year)) {
//       fetchData(`api/assignedClientStats/year/${year}/`);
//       fetchDataMissingAppointment(`api/missing-appointment/year/${year}/`);
//     }
//   }, [year, fetchData, fetchDataMissingAppointment, validateYear]);

//   useEffect(() => {
//     if (week) {
//       fetchData(`api/assignedClientStats/week/${week}/`);
//       fetchDataMissingAppointment(`api/missing-appointment/week/${week}/`);
//     }
//   }, [week, fetchData, fetchDataMissingAppointment]);

//   const handleMonthChange = (e) => {
//     setMonth(e.target.value);
//     setYear("");
//     setWeek("");
//   };

//   const handleYearChange = (e) => {
//     const value = e.target.value;
//     setYear(value);
//     setMonth("");
//     setWeek("");
//     validateYear(value);
//   };

//   const handleWeekChange = (e) => {
//     const selectedDate = e.target.value;
//     if (selectedDate) {
//       const mondayDate = getMondayOfWeek(selectedDate);
//       setWeek(mondayDate);
//     } else {
//       setWeek("");
//     }
//     setMonth("");
//     setYear("");
//   };

//   // Clear all filters
//   const handleClearFilters = () => {
//     setMonth("");
//     setYear("");
//     setWeek("");
//     setYearError("");
//     setData([]);
//     setMissingData([]);
//   };

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 } }}>
//       {/* Inform users about Monday requirement */}
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         {t(
//           "Note: For weekly stats, please select a Monday. The system will automatically adjust to the Monday of the selected week."
//         )}
//       </Typography>

//       {/* Input Fields */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom>
//               {t("Assigned Patient Stats by Week")}
//             </Typography>
//             <TextField
//               type="date"
//               value={week}
//               onChange={handleWeekChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom>
//               {t("Assigned Patient Stats by Month")}
//             </Typography>
//             <TextField
//               type="month"
//               value={month}
//               onChange={handleMonthChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Typography variant="h6" gutterBottom>
//               {t("Assigned Patient Stats by Year")}
//             </Typography>
//             <TextField
//               type="number"
//               value={year}
//               onChange={handleYearChange}
//               fullWidth
//               variant="outlined"
//               InputProps={{
//                 inputProps: { min: 2000, max: 2100 },
//               }}
//               InputLabelProps={{ shrink: true }}
//               error={!!yearError}
//               helperText={yearError}
//             />
//           </Grid>
//           <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={handleClearFilters}
//               sx={{ mt: 2 }}
//             >
//               {t("Clear Filters")}
//             </Button>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Assigned Client Stats Chart */}
//       <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
//         {data.length > 0 ? (
//           <ResponsiveContainer width="100%" height={400}>
//             <BarChart
//               data={data}
//               margin={{
//                 top: 5,
//                 right: 30,
//                 left: 20,
//                 bottom: 5,
//               }}
//             >
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis
//                 dataKey="name"
//                 label={{
//                   value: "Staff Name",
//                   position: "insideBottomRight",
//                   offset: -5,
//                 }}
//               />
//               <YAxis
//                 label={{ value: "Total", angle: -90, position: "insideLeft" }}
//               />
//               <Tooltip />
//               <Legend />
//               <Bar dataKey="total" fill="#8884d8" barSize={50} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <Typography>{t("No data available for the selected period")}.</Typography>
//         )}
//       </Paper>

//       {/* Missing Appointment Chart */}
//       <Paper elevation={3} sx={{ p: 3 }}>
//         <Divider sx={{ my: 2 }} />
//         <Typography variant="h6" gutterBottom>
//           {t("Missing Appointment by Patients")}
//         </Typography>
//         {missingData.length > 0 ? (
//           <ResponsiveContainer width="100%" height={400}>
//             <BarChart
//               data={missingData}
//               margin={{
//                 top: 5,
//                 right: 30,
//                 left: 20,
//                 bottom: 5,
//               }}
//             >
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis
//                 dataKey="name"
//                 label={{
//                   value: "Staff Name",
//                   position: "insideBottomRight",
//                   offset: -5,
//                 }}
//               />
//               <YAxis
//                 label={{ value: "Total", angle: -90, position: "insideLeft" }}
//               />
//               <Tooltip />
//               <Legend />
//               <Bar dataKey="total" fill="#8884d8" barSize={50} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <Typography>
//             {t("No Missing Appointment data available for the selected period")}.
//           </Typography>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default AssignedClientStats;


import { useState, useEffect, useCallback } from "react";
import axiosClient from "../axiosClient";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useStateContext } from "../context/ContextProvider";
import { useTranslation } from "react-i18next";
import {
  Grid,
  TextField,
  Typography,
  Box,
  Divider,
  Paper,
  Button,
} from "@mui/material";

const AssignedClientStats = () => {
  const [data, setData] = useState([]);
  const [missingData, setMissingData] = useState([]);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [week, setWeek] = useState("");
  const [yearError, setYearError] = useState("");
  const { user } = useStateContext();
  const { t } = useTranslation();

  const getMondayOfWeek = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDay();
    const diff = day === 0 ? -6 : -day + 1;
    date.setDate(date.getDate() + diff);
    return date.toISOString().split("T")[0];
  };

  const validateYear = useCallback(
    (year) => {
      if (!year) return true;
      const yearNum = parseInt(year, 10);
      if (isNaN(yearNum) || yearNum < 2000 || yearNum > 2100) {
        setYearError(t("reports.yearValidationError"));
        return false;
      }
      setYearError("");
      return true;
    },
    [t]
  );

  const { token } = user;

  const fetchData = useCallback(
    (url) => {
      axiosClient
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data && Array.isArray(response.data)) {
            setData(response.data);
          } else {
            console.error("Invalid data format:", response.data);
            setData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setData([]);
        });
    },
    [token]
  );

  const fetchDataMissingAppointment = useCallback(
    (url) => {
      axiosClient
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data && Array.isArray(response.data)) {
            setMissingData(response.data);
          } else {
            console.error("Invalid data format:", response.data);
            setMissingData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setMissingData([]);
        });
    },
    [token]
  );

  useEffect(() => {
    if (month) {
      const [year, mon] = month.split("-");
      fetchData(`api/assignedClientStats/month/${mon}-${year}/`);
      fetchDataMissingAppointment(
        `api/missing-appointment/month/${mon}-${year}/`
      );
    }
  }, [month, fetchData, fetchDataMissingAppointment]);

  useEffect(() => {
    if (year && validateYear(year)) {
      fetchData(`api/assignedClientStats/year/${year}/`);
      fetchDataMissingAppointment(`api/missing-appointment/year/${year}/`);
    }
  }, [year, fetchData, fetchDataMissingAppointment, validateYear]);

  useEffect(() => {
    if (week) {
      fetchData(`api/assignedClientStats/week/${week}/`);
      fetchDataMissingAppointment(`api/missing-appointment/week/${week}/`);
    }
  }, [week, fetchData, fetchDataMissingAppointment]);

  const handleMonthChange = (e) => {
    setMonth(e.target.value);
    setYear("");
    setWeek("");
  };

  const handleYearChange = (e) => {
    const value = e.target.value;
    setYear(value);
    setMonth("");
    setWeek("");
    validateYear(value);
  };

  const handleWeekChange = (e) => {
    const selectedDate = e.target.value;
    if (selectedDate) {
      const mondayDate = getMondayOfWeek(selectedDate);
      setWeek(mondayDate);
    } else {
      setWeek("");
    }
    setMonth("");
    setYear("");
  };

  const handleClearFilters = () => {
    setMonth("");
    setYear("");
    setWeek("");
    setYearError("");
    setData([]);
    setMissingData([]);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      {/* Note for weekly stats */}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t("reports.weekNote")}
      </Typography>

      {/* Filters */}
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("reports.statsByWeek")}
            </Typography>
            <TextField
              type="date"
              value={week}
              onChange={handleWeekChange}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("reports.statsByMonth")}
            </Typography>
            <TextField
              type="month"
              value={month}
              onChange={handleMonthChange}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t("reports.statsByYear")}
            </Typography>
            <TextField
              type="number"
              value={year}
              onChange={handleYearChange}
              fullWidth
              variant="outlined"
              InputProps={{
                inputProps: { min: 2000, max: 2100 },
              }}
              InputLabelProps={{ shrink: true }}
              error={!!yearError}
              helperText={yearError}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClearFilters}
              sx={{ mt: 2 }}
            >
              {t("Clear Filters")}
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Assigned Client Stats Chart */}
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        {data.length > 0 ? (
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={data}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                label={{
                  value: t("assignedStats.staffName"),
                  position: "insideBottomRight",
                  offset: -5,
                }}
              />
              <YAxis
                label={{
                  value: t("assignedStats.total"),
                  angle: -90,
                  position: "insideLeft",
                }}
              />
              <Tooltip />
              <Legend />
              <Bar dataKey="total" fill="#8884d8" barSize={50} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Typography>{t("reports.noDataForPeriod")}</Typography>
        )}
      </Paper>

      {/* Missing Appointment Chart */}
      <Paper elevation={3} sx={{ p: 3 }}>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" gutterBottom>
          {t("assignedStats.missingTitle")}
        </Typography>
        {missingData.length > 0 ? (
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={missingData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                label={{
                  value: t("assignedStats.staffName"),
                  position: "insideBottomRight",
                  offset: -5,
                }}
              />
              <YAxis
                label={{
                  value: t("assignedStats.total"),
                  angle: -90,
                  position: "insideLeft",
                }}
              />
              <Tooltip />
              <Legend />
              <Bar dataKey="total" fill="#8884d8" barSize={50} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Typography>
            {t("assignedStats.noMissingData")}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default AssignedClientStats;
